import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { ReactElement, ReactNode, forwardRef } from 'react';
import Tooltip from 'react-bootstrap/Tooltip';

interface TooltipProps {
    title: string | undefined;
    children: ReactElement | ((props: any) => ReactNode);
}

function CustomTooltip({ title, children }: TooltipProps) {

    return (
        <OverlayTrigger
            overlay={
                <Tooltip
                    style={{ whiteSpace: 'pre-line' }}
                >
                    {title}
                </Tooltip>
            }>
            {children}
        </OverlayTrigger>
    )

}

export default CustomTooltip;